export const toolsEn = {
  title: "Tools",
  subtitle: "Tools to support you in this course of action.",
  loading: "Loading…",
  error: "Something went wrong.",
  retry: "Retry",
  types: {
    guide: "Practical guide",
    action_sheet: "Action sheet",
    video: "Video",
    analysis_grid: "Analysis grid",
    other: "Other",
  },
  directory: {
    heading: "Tools",
    help: "Tools offered for this course of action.",
    resultCount_one: "{{count}} tool",
    resultCount_other: "{{count}} tools",
    favoriteCount_one: "{{count}} favorite",
    favoriteCount_other: "{{count}} favorites",
    seeMore_one: "See {{count}} more tool",
    seeMore_other: "See {{count}} more tools",
    none: "No tool is available yet for this course of action.",
    noneFiltered: "No tool matches the selected filters.",
    noFavorites: "You do not have any favorite tool yet for this course of action.",
    seeAll: "See all tools",
    unavailable: "Tools are not available for this course of action.",
    actionRequired: {
      title: "Select a course of action",
      help: "Tools are consulted from a course of action in your action plan.",
      goToPlans: "Go to the action plan",
    },
  },
  card: {
    by: "By {{author}}",
    access: "Access the tool",
    seeMore: "See more",
    seeLess: "See less",
    favorite: "Add to favorites",
    unfavorite: "Remove from favorites",
  },
  filters: {
    sectorsServed: "Associated sectors",
    companySizes: "Company size",
    orgTypes: "Associated organization types",
    heading: "Filters",
    search: "Title, author…",
    type: "Tool type",
    favoritesOnly: "My favorites only",
  },
  cell: {
    column: "Tools",
    all: "Consult tools for this course of action",
    favorites: "Consult your favorite tools for this course of action",
  },
  admin: {
    title: "Manage tools",
    create: "Create a tool",
    editTool: "Edit the tool",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    empty: "No tools.",
    countTotal_one: "{{count}} tool in total",
    countTotal_other: "{{count}} tools in total",
    linkChangeToValidate: "To validate",
    linkChangePending: "Pending",
    orderToValidate: "Order to validate",
    orderPending: "Order pending",
    import: "Import tools",
    importActions: "Import associations",
    importHelp: "Upload a tools .xlsx workbook.",
    importCancelledReviews_one:
      "The import cancelled 1 review in progress: {{titles}}.",
    importCancelledReviews_other:
      "The import cancelled {{count}} reviews in progress: {{titles}}.",
    imported:
      "Import complete: {{created}} created, {{updated}} updated, {{skipped}} skipped.",
    actionsImported:
      "Import complete: {{pairs}} association(s) applied for {{tools}} tool(s).",
    created: "Tool created.",
    updated: "Tool updated.",
    deleted: "Tool deleted.",
    confirmDelete: "Delete this tool?",
    history: "History",
    actionCount_one: "{{count}} course of action",
    actionCount_other: "{{count}} courses of action",
    otherToggle: "Other — please specify",
    status: {
      pending: "Pending",
      unassociated: "Not associated",
      inactive: "Inactive",
      active: "Active",
    },
    fields: {
      title: "Title",
      author: "Author",
      publicationYear: "Publication year",
      type: "Tool type",
      summary: "Summary",
      pageChapter: "Page / chapter",
      resourceUrl: "Link to the tool",
      sectorsServed: "Sectors served",
      companySizes: "Company sizes served",
      organizationTypes: "Targeted organization types",
      sectorsServedOther: "Other targeted sectors",
      organizationTypesOther: "Other targeted organization types",
      isActive: "Active",
      isInactive: "Inactive",
      actions: "Linked courses of action",
    },
  },
  linkOrder: {
    section: "Tool order per course of action",
    sectionHint:
      "Every order change must be validated by another administrator.",
    pending: "Pending",
    toValidate: "To validate",
    open: "Tool order ({{count}})",
    title: "Tool order",
    intro:
      "Drag and drop to set the display order. Another administrator will have to validate the change.",
    introMine:
      "You proposed this change. Another administrator must validate it — you cannot validate your own proposal.",
    introReview:
      "Review the proposed order, then approve it or make a counter-proposal.",
    linkChangeWarning:
      "An association change is pending for this course of action: the list may still gain or lose an item.",
    notVisible: "not visible",
    new: "new",
    was: "was {{n}}",
    proposedBy: "Proposed by {{name}}",
    addedSince: "Added since the proposal — placed last",
    note: "Note",
    noteLabel: "Note — required",
    notePlaceholder: "Explain your counter-proposal…",
    propose: "Propose this order",
    approve: "Approve",
    counter: "Counter-propose",
    submitCounter: "Submit counter-proposal",
    close: "Close",
  },
  linkChange: {
    awaiting_one:
      "{{count}} tool has a course-of-action change awaiting your validation.",
    awaiting_other:
      "{{count}} tools have a course-of-action change awaiting your validation.",
    openReview: "To validate",
    pendingOnly: "Awaiting validation only",
    noneAwaiting: "No change is awaiting validation.",
    reviewTitle: "Tools · to validate",
    reviewIntro: "Proposed by other people.",
    reviewIntroOwn: "You cannot validate your own proposals.",
    review: "Review",
    proposedBy: "Proposed by {{name}}",
    note: "Note",
    noteLabel: "Note — required",
    notePlaceholder: "Explain your counter-proposal…",
    noDifference: "No difference detected.",
    count_one: "{{count}} proposal",
    count_other: "{{count}} proposals",
    later: "Later",
    approveAll: "Approve all",
    formPendingMine:
      "You proposed this change. Another administrator must validate it — you cannot validate your own proposal.",
    formPendingReview:
      "Review the proposed change, then approve it or make a counter-proposal.",
    approve: "Approve",
    counter: "Counter-propose",
    cancelCounter: "Cancel the counter-proposal",
    submitCounter: "Submit the counter-proposal",
    saveOthers: "Save the other fields",
    staged:
      "The course-of-action change is awaiting validation by another administrator.",
    frozen:
      "The courses of action were not changed: a change is already awaiting validation.",
    approved: "Course-of-action change approved.",
    countered: "Counter-proposal recorded, awaiting another person.",
    noneToApprove: "No change to approve.",
    approvedCount_one: "{{count}} course-of-action change approved.",
    approvedCount_other: "{{count}} course-of-action changes approved.",
  },
  picker: {
    newLink: "new",
    lockedEmpty:
      "None — the tool would no longer have any linked course of action.",
    lockedHint: "Change awaiting validation: the proposed list is shown and cannot be edited.",
    add: "Add courses of action",
    hint:
      "Courses of action linked to this tool, in questionnaire order. The order tools appear in for an enterprise is set per course of action.",
    empty: "No courses of action linked yet.",
    remove: "Remove",
    modalTitle: "Add courses of action",
    searchActions: "Search a course of action…",
    allIssues: "All issues",
    allGoals: "All goals",
    searchIssue: "Search an issue…",
    searchGoal: "Search a goal…",
    selectAll: "Select all",
    confirm: "Confirm selection",
    linkedTag: "linked",
    matchCount_one: "{{count}} course of action",
    matchCount_other: "{{count}} courses of action",
    selectedCount_one: "{{count}} selected",
    selectedCount_other: "{{count}} selected",
    noMatch: "No course of action matches.",
  },
};
